// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26yoJ","title":"styles_title__2wb9R"};